import Vue from 'vue'
import Router from 'vue-router'


/////////////////////////公用/////////////////////
/*import login from '@/public/login'// 登录
import my_information from '@/public/my_information'// 我的信息
import my_information_personal from '@/public/my_information_personal'// 个人信息
import guide from '@/public/guide'// 引导页
import advertise from '@/public/advertise'// 广告页面
import csfile from '@/public/cs'// 广告页面
import QRCode from '@/public/QRCode'// 二维码提示页面
import pc_code_login from '@/public/pc_code_login'// 二维码扫描登录*/
const login = ()=>import("@/public/login")// 登录
const my_information = ()=>import("@/public/my_information")// 我的信息
const my_information_personal = ()=>import("@/public/my_information_personal")// 个人信息
const guide = ()=>import("@/public/guide")// 引导页
const advertise = ()=>import("@/public/advertise")// 广告页面
const csfile = ()=>import("@/public/cs")// 广告页面
const distributionshare = ()=>import("@/public/distributionshare")// 广告页面
const QRCode = ()=>import("@/public/QRCode")// 二维码提示页面
const pc_code_login = ()=>import("@/public/pc_code_login")// 二维码扫描登录
const new_register = ()=>import("@/public/new_register")// 扫描用户信息填写注册
const QRLogin = ()=>import("@/public/QRLogin")// 扫描登录
const teacher_login = ()=>import("@/public/teacher_login")// 老师业务登录
const errorprompt = ()=>import("@/public/errorprompt")// 错误提示
const NewPCLogin = ()=>import("@/public/NewPCLogin")// PC登录页面
const Codescanningtips = ()=>import("@/public/Codescanningtips")// 扫码提示
const purchase_info = ()=>import("@/public/purchase_info")// 购买提示
const purchase_pay = ()=>import("@/public/purchase_pay")// 购买信息
const purchase_pay_finish = ()=>import("@/public/purchase_pay_finish")// 购买结果

/////////////////////////管理/////////////////////
/*import s_index from '@/server/s_index'// 首页
import testPaper_screen from '@/server/testPaper_screen'// 试卷筛选
import numbergl from '@/server/numbergl'// 账号管理
import classgl from '@/server/classgl'// 班级管理
import classgl_student from '@/server/classgl_student'// 班级分配学生
import classgl_student_qk from '@/server/classgl_student_qk'// 班级学生情况
import classgl_student_follow from '@/server/classgl_student_follow'// 学生收藏情况
import workgl from '@/server/workgl'// 任务管理
import workgl_info from '@/server/workgl_info'// 任务信息
import workgl_wcinfo from '@/server/workgl_wcinfo'// 完成情况
import point_gl from '@/server/point_gl'// 分点管理
import point_info from '@/server/point_info'// 分点信息
import point_testpaper_set from '@/server/point_testpaper_set'// 试卷信息
import point_package_set from '@/server/point_package_set'// 资费管理
import point_authority from '@/server/point_authority'// 资费管理
import t_index from '@/server/t_index'// 分点管理老师首页
import numbergl_package_set from '@/server/numbergl_package_set'// 学生资费设置
import teacher_gl from '@/server/teacher_gl'// 老师设置
import teacher_team_info from '@/server/teacher_team_info'// 班级信息
import manage_info from '@/server/manage_info'// 管理信息
import point_workgl from '@/server/point_workgl'// 任务管理
import jg_info from '@/server/jg_info'// 机构信息
import workgl_ztsj from '@/server/workgl_ztsj'// 专题试卷
import workgl_ztsj_preview from '@/server/workgl_ztsj_preview'// 专题试卷预览
import workgl_ztsj_select from '@/server/workgl_ztsj_select'// 专题试题选择
import Journalism_gl from '@/server/Journalism_gl'// 新闻资讯管理
import Journalism_gl_info from '@/server/Journalism_gl_info'// 资讯设置
import student_log from '@/server/student_log'// 学生日志*/

const s_index = ()=>import("@/server/s_index")// 首页
const testPaper_screen = ()=>import("@/server/testPaper_screen")// 试卷筛选
const numbergl = ()=>import("@/server/numbergl")// 账号管理
const classgl = ()=>import("@/server/classgl")// 班级管理
const classgl_student = ()=>import("@/server/classgl_student")// 班级分配学生
const classgl_student_qk = ()=>import("@/server/classgl_student_qk")// 班级学生情况
const classgl_student_follow = ()=>import("@/server/classgl_student_follow")// 学生收藏情况
const workgl = ()=>import("@/server/workgl")// 任务管理
const workgl_info = ()=>import("@/server/workgl_info")// 任务信息
const workgl_wcinfo = ()=>import("@/server/workgl_wcinfo")// 完成情况
const point_gl = ()=>import("@/server/point_gl")// 分点管理
const point_info = ()=>import("@/server/point_info")// 分点信息
const point_testpaper_set = ()=>import("@/server/point_testpaper_set")// 试卷信息
const point_package_set = ()=>import("@/server/point_package_set")// 资费管理
const point_authority = ()=>import("@/server/point_authority")// 资费管理
const t_index = ()=>import("@/server/t_index")// 分点管理老师首页
const numbergl_package_set = ()=>import("@/server/numbergl_package_set")// 学生资费设置
const teacher_gl = ()=>import("@/server/teacher_gl")// 老师设置
const teacher_team_info = ()=>import("@/server/teacher_team_info")// 班级信息
const manage_info = ()=>import("@/server/manage_info")// 管理信息
const point_workgl = ()=>import("@/server/point_workgl")// 任务管理
const jg_info = ()=>import("@/server/jg_info")// 机构信息
const workgl_ztsj = ()=>import("@/server/workgl_ztsj")// 专题试卷
const workgl_ztsj_preview = ()=>import("@/server/workgl_ztsj_preview")// 专题试卷预览
const workgl_ztsj_select = ()=>import("@/server/workgl_ztsj_select")// 专题试题选择
const Journalism_gl = ()=>import("@/server/Journalism_gl")// 新闻资讯管理
const Journalism_gl_info = ()=>import("@/server/Journalism_gl_info")// 资讯设置
const student_log = ()=>import("@/server/student_log")// 学生日志
/////////////////////////前端/////////////////////
/*import index from '@/view/index'// 首页
import testPaper_screen_details from '@/view/testPaper_screen_details'// 试卷试题信息
import testPaper_screen_details_preview from '@/view/testPaper_screen_details_preview'// 试卷试题
import testPaper_screen_details_analysis from '@/view/testPaper_screen_details_analysis'// 文字解析
import testPaper_screen_details_video from '@/view/testPaper_screen_details_video'// 视频解析
import follow from '@/view/follow'// 收藏
import v_testPaper from '@/view/v_testPaper'// 试卷首页
import v_testPaper_screen from '@/view/v_testPaper_screen'// 试卷筛选
import v_testPaper_screen_details from '@/view/v_testPaper_screen_details'// 试卷试题信息
import v_testPaper_screen_proposal from '@/view/v_testPaper_screen_proposal'// 试卷评论
import v_testPaper_screen_details_preview from '@/view/v_testPaper_screen_details_preview'// 试卷试题
import v_testPaper_screen_details_analysis from '@/view/v_testPaper_screen_details_analysis'// 文字解析
import v_testPaper_screen_details_video from '@/view/v_testPaper_screen_details_video'// 视频解析
import v_package_info from '@/view/v_package_info'// 资费信息
import Journalism from '@/view/Journalism'// 新闻资讯
import Journalism_info from '@/view/Journalism_info'// 新闻资讯详细信息*/
const index = ()=>import("@/view/index")// 首页
const testPaper_screen_details = ()=>import("@/view/testPaper_screen_details")// 试卷试题信息
const testPaper_screen_details_preview = ()=>import("@/view/testPaper_screen_details_preview")// 试卷试题
const testPaper_screen_details_analysis = ()=>import("@/view/testPaper_screen_details_analysis")// 文字解析
const testPaper_screen_details_analysis_zt = ()=>import("@/view/testPaper_screen_details_analysis_zt")// 文字解析
const testPaper_screen_details_video = ()=>import("@/view/testPaper_screen_details_video")// 视频解析
const follow = ()=>import("@/view/follow")// 收藏
const v_testPaper = ()=>import("@/view/v_testPaper")// 试卷首页
const v_testPaper_screen = ()=>import("@/view/v_testPaper_screen")// 试卷筛选
const v_testPaper_screen_details = ()=>import("@/view/v_testPaper_screen_details")// 试卷试题信息
const v_testPaper_screen_proposal = ()=>import("@/view/v_testPaper_screen_proposal")// 试卷评论
const v_testPaper_screen_details_preview = ()=>import("@/view/v_testPaper_screen_details_preview")// 试卷试题
const v_testPaper_screen_details_analysis = ()=>import("@/view/v_testPaper_screen_details_analysis")// 文字解析

const v_testPaper_screen_details_video = ()=>import("@/view/v_testPaper_screen_details_video")// 视频解析
const v_testPaper_screen_details_zsd = ()=>import("@/view/v_testPaper_screen_details_zsd")// 视频解析
const v_testPaper_screen_select = ()=>import("@/view/v_testPaper_screen_select")// 试卷搜索


const v_package_info = ()=>import("@/view/v_package_info")// 资费信息
const Journalism = ()=>import("@/view/Journalism")// 新闻资讯
const Journalism_info = ()=>import("@/view/Journalism_info")// 新闻资讯详细信息
const c_student_log = ()=>import("@/view/c_student_log")// 学生轨迹
const pc_empower = ()=>import("@/view/pc_empower")// PC登录授权扫描页面
const short_knowledge = ()=>import("@/view/short_knowledge")// 不足知识点
const error_bank = ()=>import("@/view/error_bank")// 错误试题
const error_bank_subject = ()=>import("@/view/error_bank_subject")// 错误试题信息
const s_testPaper_help = ()=>import("@/view/s_testPaper_help")// 试卷求助
const integral_info = ()=>import("@/view/integral_info")// 积分显示
const teacher_activity_index = ()=>import("@/view/teacher_activity_index")// 老师活动登录首页
const teacher_activity_info = ()=>import("@/view/teacher_activity_info")// 老师数据统计信息
const teacher_activity_information = ()=>import("@/view/teacher_activity_information")// 老师个人信息
const v_testPaper_screen_details_fx = ()=>import("@/view/v_testPaper_screen_details_fx")// 分享试卷页面
const v_testPaper_screen_details_video_fx = ()=>import("@/view/v_testPaper_screen_details_video_fx")// 分享试卷页面
const error_bank_short_knowledge = ()=>import("@/view/error_bank_short_knowledge")// 链接显示不足和错题
const payment_info = ()=>import("@/view/payment_info")// 支付提示页面
const payment_info_index = ()=>import("@/view/payment_info_index")// 支付提示页面
const follow_my = ()=>import("@/view/follow_my")// 支付提示页面
const error_bank_testPaper_screen_details = ()=>import("@/view/error_bank_testPaper_screen_details")// 支付提示页面
const sj_answer_list = ()=>import("@/view/sj_answer_list")// 上传答案信息

const v_testPaper_screen_details_fx_task = ()=>import("@/view/v_testPaper_screen_details_fx_task")// 任务分享

const work_zy = ()=>import("@/view/v_testPaper_screen_details_fx_work")// 任务分享
const v_testPaper_screen_details_show = ()=>import("@/view/v_testPaper_screen_details_show")// 分享后直接显示
const testPaper_screen_details_show = ()=>import("@/view/testPaper_screen_details_show")// 分享后直接显示

const v_testPaper_screen_details_new = ()=>import("@/view/v_testPaper_screen_details_new")// 试卷新展示

const work_jj = ()=>import("@/work_jj/v_testPaper_screen_details_fx_work")// 任务分享
const work_preview = ()=>import("@/work_jj/testPaper_screen_details_preview")// 任务分享
const work_analysis = ()=>import("@/work_jj/testPaper_screen_details_analysis_zt")// 任务分享


////////////////////////////////////////////////
const evaluating = ()=>import("@/evaluating/evaluating")// 评测信息
const evaluating_list = ()=>import("@/evaluating/evaluating_list")// 评测试卷
const evaluating_end = ()=>import("@/evaluating/evaluating_end")// 评测结束
const evaluating_report = ()=>import("@/evaluating/evaluating_report")// 评测报告
const evaluating_register = ()=>import("@/evaluating/evaluating_register")// 评测人信息
////////////////////////////////////////////////
const secrettraining = ()=>import("@/secrettraining/secrettraining")// 评测信息
const secrettraining_select = ()=>import("@/secrettraining/secrettraining_select")// 评测信息

////////////////////////////授权////////////////////////////////////
const authorize = ()=>import("@/authorize/authorize")// 授权页面

///////////////专题/////////////////////
const sp_index = ()=>import("@/special/index")// 专题首页
const sp_v_testPaper_screen = ()=>import("@/special/v_testPaper_screen")// 专题首页
const sp_v_testPaper_screen_details = ()=>import("@/special/v_testPaper_screen_details")// 专题试卷信息

//////////////////////////////////////////////////////////
const v_school_list = ()=>import("@/view/v_school_list")// 目录信息
/////////////////////////////后端充值/////////////////////////////
const jginfo = ()=>import("@/serverpay/jginfo")// 目录信息
const jg_pay = ()=>import("@/serverpay/jg_pay")// 目录信息
const jg_pay_finish = ()=>import("@/serverpay/jg_pay_finish")// 目录信息

const Notariff = ()=>import("@/error/Notariff")// 无资费
const Notloggedin = ()=>import("@/error/Notloggedin")// 未登录
const Notfollowed = ()=>import("@/error/Notfollowed")// 未关注

const knowledge = ()=>import("@/knowledge/knowledge")//
const knowledge_play = ()=>import("@/knowledge/knowledge_play")//

const testpaper_1 = ()=>import("@/testpaper/v_testPaper_screen_details")//
const testpaper_1_preview = ()=>import("@/testpaper/v_testPaper_screen_details_preview")//
const testpaper_1_video = ()=>import("@/testpaper/v_testPaper_screen_details_video")//


////////////////////////////前置知识点/////////////////////
const FrontInfo = ()=>import("@/FrontInfo/FrontInfo")//
const FrontInfo_play = ()=>import("@/FrontInfo/FrontInfo_play")//
const current_k = ()=>import("@/FrontInfo/current_k")//


const Lessonhours = ()=>import("@/view/Lessonhours")//

Vue.use(Router)
const router = new Router({
	//mode:'history',
	routes: [
		{
			path: '/index',
			name: 'index',
			component: index,
			meta:{
				title: "任务信息",
				requireAuth:true
			}
		},
		{
			path: '/my_information',
			name: 'my_information',
			component: my_information,
			meta:{
				title: "我的信息",
				requireAuth:true
			}
		},  
		{
			path: '/Codescanningtips',
			name: 'Codescanningtips',
			component: Codescanningtips,
			meta:{
				title: "视频预览",
				requireAuth:true
			}
		},  
		{
			path: '/purchase_info',
			name: 'purchase_info',
			component: purchase_info,
			meta:{
				title: "提示",
				requireAuth:true
			}
		},  
		{
			path: '/jginfo',
			name: 'jginfo',
			component: jginfo,
			meta:{
				title: "机构信息",
				requireAuth:true
			}
		},  
		{
			path: '/jg_pay',
			name: 'jg_pay',
			component: jg_pay,
			meta:{
				title: "充值",
				requireAuth:true
			}
		}, 
		{
			path: '/jg_pay_finish',
			name: 'jg_pay_finish',
			component: jg_pay_finish,
			meta:{
				title: "充值结果",
				requireAuth:true
			}
		}, 
		{
			path: '/Lessonhours',
			name: 'Lessonhours',
			component: Lessonhours,
			meta:{
				title: "课时信息",
				requireAuth:true
			}
		}, 
		{
			path: '/purchase_pay',
			name: 'purchase_pay',
			component: purchase_pay,
			meta:{
				title: "购买信息",
				requireAuth:true
			}
		}, 
		{
			path: '/purchase_pay_finish',
			name: 'purchase_pay_finish',
			component: purchase_pay_finish,
			meta:{
				title: "购买结果",
				requireAuth:true
			}
		}, 								
		{
			path: '/testPaper_screen',
			name: 'testPaper_screen',
			component: testPaper_screen,
			meta:{
				title: "试卷筛选",
				requireAuth:true
			}
		},
		{
			path: '/testPaper_screen_details_show',
			name: 'testPaper_screen_details_show',
			component: testPaper_screen_details_show,
			meta:{
				title: "试卷试题信息",
				requireAuth:true
			}
		},
		{
			path: '/testPaper_screen_details',
			name: 'testPaper_screen_details',
			component: testPaper_screen_details,
			meta:{
				title: "试卷试题信息",
				requireAuth:true
			}
		},
		{
			path: '/v_testPaper_screen_details_new',
			name: 'v_testPaper_screen_details_new',
			component: v_testPaper_screen_details_new,
			meta:{
				title: "试卷试题信息",
				requireAuth:true
			}
		},		
		{
			path: '/testPaper_screen_details_preview',
			name: 'testPaper_screen_details_preview',
			component: testPaper_screen_details_preview,
			meta:{
				title: "空白试卷",
				requireAuth:true
			}
		},
		{
			path: '/testPaper_screen_details_analysis',
			name: 'testPaper_screen_details_analysis',
			component: testPaper_screen_details_analysis,
			meta:{
				title: "试卷答案",
				requireAuth:true
			}
		},  	
		{
			path: '/testPaper_screen_details_analysis_zt',
			name: 'testPaper_screen_details_analysis_zt',
			component: testPaper_screen_details_analysis_zt,
			meta:{
				title: "试卷答案",
				requireAuth:true
			}
		}, 		
		{
			path: '/testPaper_screen_details_video',
			name: 'testPaper_screen_details_video',
			component: testPaper_screen_details_video,
			meta:{
				title: "视频讲解",
				requireAuth:true
			}
		}, 
		{
			path: '/my_information_personal',
			name: 'my_information_personal',
			component: my_information_personal,
			meta:{
				title: "个人信息",
				requireAuth:true
			}
		},   
		{
			path: '/login',
			name: 'login',
			component: login,
			meta:{
				title: "登录",
			}
		}, 
		{
			path: '/numbergl',
			name: 'numbergl',
			component: numbergl,
			meta:{
				title: "账号管理",
				requireAuth:true
			}
		}, 
		{
			path: '/classgl',
			name: 'classgl',
			component: classgl,
			meta:{
				title: "班级管理",
				requireAuth:true
			}
		},   
		{
			path: '/classgl_student',
			name: 'classgl_student',
			component: classgl_student,
			meta:{
				title: "分配学生",
				requireAuth:true
			}
		},  
		{
			path: '/classgl_student_qk',
			name: 'classgl_student_qk',
			component: classgl_student_qk,
			meta:{
				title: "学生情况",
				requireAuth:true
			}
		},  
		{
			path: '/classgl_student_follow',
			name: 'classgl_student_follow',
			component: classgl_student_follow,
			meta:{
				title: "学生收藏信息",
				requireAuth:true
			}
		},    	
		{
			path: '/workgl',
			name: 'workgl',
			component: workgl,
			meta:{
				title: "任务管理",
				requireAuth:true
			}
		}, 
		{
			path: '/workgl_info',
			name: 'workgl_info',
			component: workgl_info,
			meta:{
				title: "任务信息",
				requireAuth:true
			}
		},  
		{
			path: '/workgl_wcinfo',
			name: 'workgl_wcinfo',
			component: workgl_wcinfo,
			meta:{
				title: "完成情况",
				requireAuth:true
			}
		},  
		{
			path: '/follow',
			name: 'follow',
			component: follow,
			meta:{
				title: "收藏夹",
				requireAuth:true
			}
		},  
		{
			path: '/guide',
			name: 'guide',
			component: guide,
			meta:{
				title: "",
			}
		}, 
		{
			path: '/v_testPaper',
			name: 'v_testPaper',
			component: v_testPaper,
			meta:{
				title: "真题信息",
				requireAuth:true
			}
		},  
		{
			path: '/v_school_list',
			name: 'v_school_list',
			component: v_school_list,
			meta:{
				title: "目录信息",
				requireAuth:true
			}
		},  			
		{
			path: '/v_testPaper_screen',
			name: 'v_testPaper_screen',
			component: v_testPaper_screen,
			meta:{
				title: "试卷列表",
				requireAuth:true
			}
		},
		{
			path: '/v_testPaper_screen_select',
			name: 'v_testPaper_screen_select',
			component: v_testPaper_screen_select,
			meta:{
				title: "试卷筛选",
				requireAuth:true
			}
		},		
		{
			path: '/v_testPaper_screen_details',
			name: 'v_testPaper_screen_details',
			component: v_testPaper_screen_details,
			meta:{
				title: "试卷试题信息",
				requireAuth:true
			}
		},
		{
			path: '/testpaper_1',
			name: 'testpaper_1',
			component: testpaper_1,
			meta:{
				title: "试卷试题信息",
				requireAuth:true
			}
		},				
		{
			path: '/v_testPaper_screen_proposal',
			name: 'v_testPaper_screen_proposal',
			component: v_testPaper_screen_proposal,
			meta:{
				title: "试卷评论",
				requireAuth:true
			}
		},    	
		{
			path: '/v_testPaper_screen_details_preview',
			name: 'v_testPaper_screen_details_preview',
			component: v_testPaper_screen_details_preview,
			meta:{
				title: "真题试卷",
				requireAuth:true
			}
		}, 
		{
			path: '/testpaper_1_preview',
			name: 'testpaper_1_preview',
			component: testpaper_1_preview,
			meta:{
				title: "真题试卷",
				requireAuth:true
			}
		}, 		
		{
			path: '/v_testPaper_screen_details_analysis',
			name: 'v_testPaper_screen_details_analysis',
			component: v_testPaper_screen_details_analysis,
			meta:{
				title: "试卷答案",
				requireAuth:true
			}
		},     
		{
			path: '/v_testPaper_screen_details_video',
			name: 'v_testPaper_screen_details_video',
			component: v_testPaper_screen_details_video,
			meta:{
				title: "视频讲解",
				requireAuth:true
			}
		}, 
		{
			path: '/testpaper_1_video',
			name: 'testpaper_1_video',
			component: testpaper_1_video,
			meta:{
				title: "视频讲解",
				requireAuth:true
			}
		}, 		 
		{
			path: '/v_testPaper_screen_details_zsd',
			name: 'v_testPaper_screen_details_zsd',
			component: v_testPaper_screen_details_zsd,
			meta:{
				title: "知识点",
				requireAuth:true
			}
		},  		
		{
			path: '/s_index',
			name: 's_index',
			component: s_index,
			meta:{
				title: "首页",
				requireAuth:true
			}
		},   
		{
			path: '/point_gl',
			name: 'point_gl',
			component: point_gl,
			meta:{
				title: "分点管理",
				requireAuth:true
			}
		}, 
		{
			path: '/point_info',
			name: 'point_info',
			component: point_info,
			meta:{
				title: "分点信息",
				requireAuth:true
			}
		},    
		{
			path: '/point_testpaper_set',
			name: 'point_testpaper_set',
			component: point_testpaper_set,
			meta:{
				title: "试卷设置",
				requireAuth:true
			}
		},    
		{
			path: '/point_package_set',
			name: 'point_package_set',
			component: point_package_set,
			meta:{
				title: "资费管理",
				requireAuth:true
			}
		},  
		{
			path: '/point_authority',
			name: 'point_authority',
			component: point_authority,
			meta:{
				title: "权限管理",
				requireAuth:true
			}
		},      
		{
			path: '/t_index',
			name: 't_index',
			component: t_index,
			meta:{
				title: "首页",
				requireAuth:true
			}
		},   
		{
			path: '/numbergl_package_set',
			name: 'numbergl_package_set',
			component: numbergl_package_set,
			meta:{
				title: "学生资费设置",
				requireAuth:true
			}
		},       
		{
			path: '/teacher_gl',
			name: 'teacher_gl',
			component: teacher_gl,
			meta:{
				title: "老师设置",
				requireAuth:true
			}
		},  
		{
			path: '/teacher_team_info',
			name: 'teacher_team_info',
			component: teacher_team_info,
			meta:{
				title: "班级信息",
				requireAuth:true
			}
		},      
		{
			path: '/manage_info',
			name: 'manage_info',
			component: manage_info,
			meta:{
				title: "管理信息",
				requireAuth:true
			}
		},   
		{
			path: '/point_workgl',
			name: 'point_workgl',
			component: point_workgl,
			meta:{
				title: "任务管理",
				requireAuth:true
			}
		},     
		{
			path: '/advertise',
			name: 'advertise',
			component: advertise,
			meta:{
				title: "提示信息",
				requireAuth:true
			}
		},  
		{
			path: '/v_package_info',
			name: 'v_package_info',
			component: v_package_info,
			meta:{
				title: "资费信息",
				requireAuth:true
			}
		},   
		{
			path: '/jg_info',
			name: 'jg_info',
			component: jg_info,
			meta:{
				title: "机构信息",
				requireAuth:true
			}
		},  
		{
			path: '/csfile',
			name: 'csfile',
			component: csfile,
			meta:{
				title: "机构信息",

			}
		},
		{
			path: '/distributionshare',
			name: 'distributionshare',
			component: distributionshare,
			meta:{
				title: "分销分享",

			}
		},
		{
			path: '/workgl_ztsj',
			name: 'workgl_ztsj',
			component: workgl_ztsj,
			meta:{
				title: "专题试卷",
				requireAuth:true
			}
		},   
		{
			path: '/workgl_ztsj_preview',
			name: 'workgl_ztsj_preview',
			component: workgl_ztsj_preview,
			meta:{
				title: "试卷预览",
				requireAuth:true
			}
		},
		{
			path: '/Notariff',
			name: 'Notariff',
			component: Notariff,
			meta:{
				title: "未购买",
				requireAuth:true
			}
		}, 
		{
			path: '/Notloggedin',
			name: 'Notloggedin',
			component: Notloggedin,
			meta:{
				title: "未登录",
				requireAuth:true
			}
		},	
		{
			path: '/Notfollowed',
			name: 'Notfollowed',
			component: Notfollowed,
			meta:{
				title: "未关注",
				requireAuth:true
			}
		},				
		{
			path: '/QRCode',
			name: 'QRCode',
			component: QRCode,
			meta:{
				title: "未关注提示",
			}
		},  
		{
			path: '/Journalism',
			name: 'Journalism',
			component: Journalism,
			meta:{
				title: "新闻资讯",
			}
		},  
		{
			path: '/Journalism_info',
			name: 'Journalism_info',
			component: Journalism_info,
			meta:{
				title: "新闻资讯",
			}
		},   
		{
			path: '/Journalism_gl',
			name: 'Journalism_gl',
			component: Journalism_gl,
			meta:{
				title: "新闻资讯管理",
				requireAuth:true
			}
		},  
		{
			path: '/Journalism_gl_info',
			name: 'Journalism_gl_info',
			component: Journalism_gl_info,
			meta:{
				title: "资讯设置",
				requireAuth:true
			}
		},      
		{
			path: '/workgl_ztsj_select',
			name: 'workgl_ztsj_select',
			component: workgl_ztsj_select,
			meta:{
				title: "专题试题选择",
				requireAuth:true
			}
		},  
		{
			path: '/student_log',
			name: 'student_log',
			component: student_log,
			meta:{
				title: "学生日志",
				requireAuth:true
			}
		}, 
		{
			path: '/knowledge',
			name: 'knowledge',
			component: knowledge,
			meta:{
				title: "知识点",
				requireAuth:true,
				keepAlive: 1,
			}
		},
		{
			path: '/current_k',
			name: 'current_k',
			component: current_k,
			meta:{
				title: "当前知识点",
				requireAuth:true,
			}
		},		
		{
			path: '/FrontInfo',
			name: 'FrontInfo',
			component: FrontInfo,
			meta:{
				title: "前置知识点",
				requireAuth:true,
			}
		},
		{
			path: '/FrontInfo_play',
			name: 'FrontInfo_play',
			component: FrontInfo_play,
			meta:{
				title: "前置知识点",
				requireAuth:true,
			}
		},
		
		{
			path: '/knowledge_play',
			name: 'knowledge_play',
			component: knowledge_play,
			meta:{
				title: "知识点信息",
				requireAuth:true
			}
		}, 				
		{
			path: '/pc_code_login',
			name: 'pc_code_login',
			component: pc_code_login,
			meta:{
				title: "扫描登录",
			}
		},  
		{
			path: '/new_register',
			name: 'new_register',
			component: new_register,
			meta:{
				title: "注册信息",
			}
		},  	   
		{
			path: '/c_student_log',
			name: 'c_student_log',
			component: c_student_log,
			meta:{
				title: "学生轨迹",
			}
		}, 
		{
			path: '/QRLogin',
			name: 'QRLogin',
			component: QRLogin,
			meta:{
				title: "扫描登录",
			}
		}, 	
		{
			path: '/pc_empower',
			name: 'pc_empower',
			component: pc_empower,
			meta:{
				title: "授权电脑登录",
			}
		}, 
		{
		path: '/short_knowledge',
		name: 'short_knowledge',
		component: short_knowledge,
		meta:{
			title: "不足知识点",
		}
		}, 	
		{
			path: '/error_bank',
			name: 'error_bank',
			component: error_bank,
			meta:{
				title: "错题库",
			}
		}, 
		{
			path: '/error_bank_subject',
			name: 'error_bank_subject',
			component: error_bank_subject,
			meta:{
				title: "试题查看",
			}
		}, 	
		{
			path: '/s_testPaper_help',
			name: 's_testPaper_help',
			component: s_testPaper_help,
			meta:{
				title: "联系老师",
			}
		}, 	
		{
			path: '/integral_info',
			name: 'integral_info',
			component: integral_info,
			meta:{
				title: "积分情况",
			}
		}, 	
		{
			path: '/teacher_activity_index',
			name: 'teacher_activity_index',
			component: teacher_activity_index,
			meta:{
				title: "机构分销查询",
			}
		}, 	
		{
			path: '/teacher_login',
			name: 'teacher_login',
			component: teacher_login,
			meta:{
				title: "分销登录",
			}
		}, 	
		{
			path: '/teacher_activity_info',
			name: 'teacher_activity_info',
			component: teacher_activity_info,
			meta:{
				title: "详细信息",
			}
		}, 	
		{
			path: '/teacher_activity_information',
			name: 'teacher_activity_information',
			component: teacher_activity_information,
			meta:{
				title: "个人信息",
			}
		}, 
		{
			path: '/errorprompt',
			name: 'errorprompt',
			component: errorprompt,
			meta:{
				title: "提示",
			}
		}, 
		{
			path: '/v_testPaper_screen_details_fx',
			name: 'v_testPaper_screen_details_fx',
			component: v_testPaper_screen_details_fx,
			meta:{
				title: "真题试卷",
			}
		}, 
		{
			path: '/v_testPaper_screen_details_video_fx',
			name: 'v_testPaper_screen_details_video_fx',
			component: v_testPaper_screen_details_video_fx,
			meta:{
				title: "真卷试题",
			}
		}, 
		{
			path: '/v_testPaper_screen_details_fx_task',
			name: 'v_testPaper_screen_details_fx_task',
			component: v_testPaper_screen_details_fx_task,
			meta:{
				title: "分享",
			}
		}, 
		{
			path: '/v_testPaper_screen_details_show',
			name: 'v_testPaper_screen_details_show',
			component: v_testPaper_screen_details_show,
			meta:{
				title: "真题试卷",
			}
		},
		
		{
			path: '/work_zy',
			name: 'work_zy',
			component: work_zy,
			meta:{
				title: "作业",
			}
		}, 	
		{
			path: '/work_jj',
			name: 'work_jj',
			component: work_jj,
			meta:{
				title: "作业",
			}
		}, 	
		{
			path: '/work_preview',
			name: 'work_preview',
			component: work_preview,
			meta:{
				title: "预览下载",
			}
		}, 	
		{
			path: '/work_analysis',
			name: 'work_analysis',
			component: work_analysis,
			meta:{
				title: "解析查看",
			}
		}, 								
		{
			path: '/error_bank_short_knowledge',
			name: 'error_bank_short_knowledge',
			component: error_bank_short_knowledge,
			meta:{
				title: "错题不足",
			}
		}, 
		{
			path: '/sp_index',
			name: 'sp_index',
			component: sp_index,
			meta:{
				title: "专题",
			}
		}, 	
		{
			path: '/sp_v_testPaper_screen',
			name: 'sp_v_testPaper_screen',
			component: sp_v_testPaper_screen,
			meta:{
				title: "专题试卷",
			}
		}, 
		{
			path: '/sp_v_testPaper_screen_details',
			name: 'sp_v_testPaper_screen_details',
			component: sp_v_testPaper_screen_details,
			meta:{
				title: "专题试卷",
			}
		}, 										
		{
			path: '/payment_info',
			name: 'payment_info',
			component: payment_info,
			meta:{
				title: "支付信息",
			}
		},	
		{
			path: '/payment_info_index',
			name: 'payment_info_index',
			component: payment_info_index,
			meta:{
				title: "套餐信息",
			}
		},
		{
			path: '/follow_my',
			name: 'follow_my',
			component: follow_my,
			meta:{
				title: "我的收藏",
			}
		},
		{
			path: '/error_bank_testPaper_screen_details',
			name: 'error_bank_testPaper_screen_details',
			component: error_bank_testPaper_screen_details,
			meta:{
				title: "错题试卷",
			}
		},	
		{
			path: '/evaluating',
			name: 'evaluating',
			component: evaluating,
			meta:{
				title: "能力评测",
			}
		},
		{
			path: '/evaluating_list',
			name: 'evaluating_list',
			component: evaluating_list,
			meta:{
				title: "评测试题",
			}
		},	
		{
			path: '/evaluating_end',
			name: 'evaluating_end',
			component: evaluating_end,
			meta:{
				title: "评测结束",
			}
		},	
		{
			path: '/evaluating_report',
			name: 'evaluating_report',
			component: evaluating_report,
			meta:{
				title: "评测报告",
			}
		},
		{
			path: '/evaluating_register',
			name: 'evaluating_register',
			component: evaluating_register,
			meta:{
				title: "评测人信息",
			}
		},									
		{
			path: '/sj_answer_list',
			name: 'sj_answer_list',
			component: sj_answer_list,
			meta:{
				title: "上传答案",
			}
		},	
		{
			path: '/NewPCLogin',
			name: 'NewPCLogin',
			component: NewPCLogin,
			meta:{
				title: "登录",
			}
		},	
		{
			path: '/secrettraining',
			name: 'secrettraining',
			component: secrettraining,
			meta:{
				title: "密训营专区",
			}
		},
		{
			path: '/secrettraining_select',
			name: 'secrettraining_select',
			component: secrettraining_select,
			meta:{
				title: "学校选择",
			}
		},	
		{
			path: '/authorize',
			name: 'authorize',
			component: authorize,
			meta:{
				title: "授权",
			}
		},
																
		{
			path: '*', 
			redirect: '/guide',
		}    
	],
})
router.beforeEach((to,form,next) =>{
	/*路由变化修改title*/
	if(to.meta.title){
		document.title=to.meta.title		
		
		console.log(to);
		console.log(form);
		let params = {
			"api":"locuslog",
			"userid": sessionStorage.getItem('userid'),
			"token":sessionStorage.getItem('token'),
			"type":"1",
			"agencyid":sessionStorage.getItem('agencyid'),
			"event":"open",
			"pointid":sessionStorage.getItem('pointid'),
			"levelid":sessionStorage.getItem('levelid'),
			"fromname":document.title,
			"wxname":sessionStorage.getItem('nickname'),
			"wxopenid":sessionStorage.getItem('openid'),
			"explain":sessionStorage.getItem('explain'),
			"number":sessionStorage.getItem('number'),
			"fxuserid":sessionStorage.getItem('fxuserid'),
			"ffuserid":sessionStorage.getItem('ffuserid'),
			"fxtype":sessionStorage.getItem('fxtype'),
			"toname":to.name,
			"formname":form.name,
		}
		Vue.prototype.$axios({
			method: 'post',
			url: Vue.prototype.api.api.url,
			data: params
		})
		.then((res)=>{
			sessionStorage.setItem('explain', '');
			if(res.data.code == 1){	

			}				
		},(error)=>{
		})
		if(to.name!='guide' && (form.name=='null' || form.name==null))
		{
			next({
				path: '/guide',
			})
			return;				
		}
	}

	next();
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js